import React from 'react'
import '../../styles/PursueMBA.css'
import { pin, GoldCertificate, WhiteCertificate } from '../../assets/index'

const CertificateComponent = () => {
  return (
    <div className="mba-container relative top-[5rem]">
      <div className='head_container'>
        <div className="line"></div>
        <h1 className="title">Certifications</h1>
      </div>


      <p className="subtitle cSubtitle realtive lg:left-[27rem]">

        <img src={pin} alt="Pin Icon" className="pImg" />


        15+ Core Finance Professional Certifications by FINXL
      </p>



      <p className='subcontent'>
        Value-added Practical Certifications from FBS & NISM:
      </p>
      <div className="content">
        <div className="cImgBx">
          <img src={GoldCertificate} alt="Certifications Icon" className="cImg" />
        </div>
        <div className="cImgBx">
          <img src={WhiteCertificate} alt="Certifications Icon" className="cImg" />

        </div>


      </div>
      <div style={{ textAlign: 'center' }}>
        <p className="subtitle1 yColor">

          Career Services And Opportunities
        </p>
      </div>



    </div>
  );
}

export default CertificateComponent